export default {"src":"/_next/static/media/consent_storage.f75d359c.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};